<div class="demographics">
  <div class="d-flex flex-row flex-wrap">
    <div class="d-inline-flex me-5">
      <div class="header fw-bold me-2 text-nowrap">
        {{ translations.demographics.id }}:
      </div>

      <div class="d-inline-block text-nowrap">
        {{ patient?.extension }}
      </div>
    </div>

    <div class="d-inline-flex me-5">
      <div class="header fw-bold me-2 text-nowrap">
        {{ translations.demographics.name }}:
      </div>

      <div class="d-inline-block text-nowrap">
        {{ patient?.firstName }}
      </div>
    </div>

    <div class="d-inline-flex me-5">
      <div class="header fw-bold me-2 text-nowrap">
        {{ translations.demographics.surname }}:
      </div>

      <div class="d-inline-block text-nowrap">
        {{ patient?.familyName }}
      </div>
    </div>

    <div class="d-inline-flex me-5">
      <div class="header fw-bold me-2 text-nowrap">
        {{ translations.demographics.date_of_birth }}:
      </div>

      <div class="d-inline-block text-nowrap">
        {{ patient?.birthDate | date: 'dd-MM-yyyy' }}
      </div>
    </div>

    <div class="d-inline-flex me-5">
      <div class="header fw-bold me-2 text-nowrap">
        {{ translations.demographics.gender }}:
      </div>

      <div class="d-inline-block text-nowrap">
        {{ patient?.gender }}
      </div>
    </div>

    <div class="d-inline-flex me-5">
      <div class="header fw-bold me-2 text-nowrap">
        {{ translations.demographics.country }}:
      </div>

      <div class="d-inline-block text-nowrap">
        {{ selectedCountry?.countryName }}
      </div>
    </div>
  </div>
</div>

<router-outlet />
